import { DarkMode } from "@mui/icons-material";
import React, { FunctionComponent, useMemo, useState } from "react";
import { ListPhases } from "stores/phase/utils";
import SelectorDialogBase from "../base/SelectorDialogBase";
import Chip from "./Chip";



interface Props {
	phase?: string,
	onChange: (phase: string) => void,
	sx?: any
}

const SelectorPhaseH: FunctionComponent<Props> = ({
	phase,
	onChange,
	sx,
}) => {

	// STORE

	// HOOKs
	const [isOpen, setIsOpen] = useState(false)
	const [textFilter, setTextFilter] = useState("")

	// HANDLER
	const handleClick = () => {
		setIsOpen(true)
	}
	const handleClose = (phase: string) => {
		setIsOpen(false)
		if (phase) onChange?.(phase)
	}
	const handleClear = (e: React.MouseEvent) => {
		e.stopPropagation()
		setIsOpen(false)
		onChange?.(null)
	}

	// RENDER
	const phases = useMemo(()=> {
		if ( !textFilter || textFilter.length == 0 ) return ListPhases
		const text = textFilter.toLowerCase()
		return ListPhases.filter(ph => ph.toLowerCase().includes(text))
	}, [textFilter])
	
	const isActive = !!phase
	if (!phases) return null

	return (<>
		<Chip sx={sx}
			label={phase?.toUpperCase() ?? "ALL PHASES"}
			icon={ <DarkMode width={18} height={18} />}
			tooltip={"VIEW ONLY THIS PHASE"}
			active={isActive}
			onClick={handleClick}
			onClear={handleClear}
		/>
		<SelectorDialogBase
			width="auto"
			height={600}
			icon={<DarkMode />}
			items={phases}
			textValue={textFilter}
			idSelect={phase}
			title={"SELECT A PHASE"}
			isOpen={isOpen}
			onClose={handleClose}
			onClear={handleClear}
			onChangeTextValue={txt => setTextFilter(txt)}
			fnTextFromItem={item => item.toUpperCase()}
			fnIdFromItem={item => item}
		/>
	</>)
}

export default SelectorPhaseH
